
import React, { useState } from "react";
import useTheme from "../../../../hooks/useTheme";
import { AppOutlineButton } from "../../../UI/CustomButtons";
import AppText from "../../../UI/Texts/AppTexts";
import { t } from "i18next";
import { AUTH_MODAL_OVERLAY } from "../../../Authentication/authOverlay";
import { useLocation } from "react-router-dom";

const LearnMoreRegisterButton = ({ openModal, jobData }) => {
    const theme = useTheme();
    const [isHovered, setIsHovered] = useState(false);
    const location = useLocation();


    const workplace = jobData?.healthcareWorkplaceDetails ?? jobData?.workplaceDetails;

    const county = workplace?.county;
    const municipality = workplace?.municipality;

    const profession = jobData?.profession;
    const jobEmploymentTypes = jobData?.employmentTypes || [];

    const workfields = jobData?.workFields || [];


    return (
        <AppOutlineButton
            onClick={() => {
                openModal(AUTH_MODAL_OVERLAY, {
                    fallbackTargetPath: location.pathname,
                    formData: {
                        professions: profession ? [profession] : [],
                        workfields: workfields,
                        locations: [county, municipality],
                        employmentTypes: jobEmploymentTypes,
                    }
                });
            }}
            size="big"
            fiuld
            onHoverChange={(hovered) => {
                setIsHovered(hovered);
            }}
            style={{
                borderRadius: theme.radius.button,
                border: '1.5px solid',
            }}
        >
            <AppText.Caption color={isHovered ? theme.colors.white : theme.primaryColor} fontWeight={600}> {t('jobdetail.signup.create_account')}</AppText.Caption>
        </AppOutlineButton >)
}

export default LearnMoreRegisterButton;
